import { render, staticRenderFns } from "./check-your-physical-fitness-1.vue?vue&type=template&id=689b22ac&"
import script from "./check-your-physical-fitness-1.vue?vue&type=script&lang=js&"
export * from "./check-your-physical-fitness-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports